import { antaresConfig } from "@/core/modules/config";
import { LocaleStateInterface } from "../models/LocaleState.interface";

export const initialState: LocaleStateInterface = {
  locales: antaresConfig.locales,
};
